import React, { DOMElement } from "react";

export function useElementScroll(element: any) {
  const [isScrolling, setIsScrolling] = React.useState(false);
  const scrollTimeoutRef = React.useRef<any>(null);

  React.useEffect(() => {
    const handler = (event: any) => {
      if (!isScrolling) setIsScrolling(true);
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        setIsScrolling(false);
      }, 100);
    };
    element.addEventListener("scroll", handler);
    return () => element.removeEventListener("scroll", handler);
  }, []);

  return { isScrolling };
}
